import ComplaintsList from './ComplaintsList';

export default ComplaintsList;
